import { Edit, ShowButton } from "react-admin";
import { useState } from "react";
import BackButtonToolbar from "features/BackButtonToolbar";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { MobilityVisitType } from "utils/constants";
import { normalizeTravelDocumentIds } from "components/Erasmus/Partials/TravelDocumentsInput";
import SaveForm from "./Partials/SaveForm";

const DOCUMENT_SOURCES = [
  "mobilityAgreementId",
  "cvId",
  "selectionProtocolId",
  "fundingAgreementId",
  "acceptanceLetterId",
  "certificateOfStayId",
  "certificateOfTeachingId",
  "businessTripReportId",
  "businessTripOrderId",
  "medicalInsuranceId",
  "travellerReportId",
];

const EditErasmusOutgoingTeachers = () => {
  const [docIds, setDocIds] = useState({});
  const [travelDocumentIds, setTravelDocumentIds] = useState(null);

  const handleDocumentUpload = (source, id) => setDocIds(prev => ({ ...prev, [source]: id }));

  const handleSend = data => {
    const payload = {
      ...Object.fromEntries(Object.entries(data).filter(([key]) => !DOCUMENT_SOURCES.includes(key))),
      ...Object.fromEntries(DOCUMENT_SOURCES.map(key => [key, docIds[key] ?? data[key] ?? null])),
      // Full sync on update: send the complete desired set (untouched → keep the record's current docs).
      travelDocumentIds: travelDocumentIds ?? normalizeTravelDocumentIds(data.travelDocumentIds),
    };

    // certificateOfTeachingId is only valid for Study/BIP — Traineeship would be rejected (422).
    if (payload.mobilityVisitType === MobilityVisitType.Internship) {
      payload.certificateOfTeachingId = null;
    }

    // bipName/bipNumber are BIP-specific. startDate/endDate are NOT — the BE accepts a period for
    // any visit type (only required for BIP), so leave the form's dates untouched here.
    if (payload.mobilityVisitType !== MobilityVisitType.BIP) {
      payload.bipName = null;
      payload.bipNumber = null;
    }

    return payload;
  };

  return (
    <Edit
      transform={handleSend}
      mutationMode="pessimistic"
      title="Редактирай заминаващ служител"
      actions={
        <BackButtonToolbar
          additionalButton={
            <SecuredComponent permission={permissions.canPreviewErasmusOutgoingTeachers}>
              <ShowButton
                variant="contained"
                size="medium"
              />
            </SecuredComponent>
          }
        />
      }
    >
      <SaveForm
        onDocumentUpload={handleDocumentUpload}
        travelDocumentIds={travelDocumentIds}
        onTravelDocumentsChange={setTravelDocumentIds}
      />
    </Edit>
  );
};

export default EditErasmusOutgoingTeachers;
